import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const CreateProfileComponent = Loadable(() => import('..'));

export default MapTo('vcg/components/soe-home/react/createprofile')(CreateProfileComponent);
